class SettingsController {
  /*@ngInject*/
  constructor($state, $timeout, $rootScope, $window) {
    this.$timeout = $timeout
    this.$state = $state
    this.$rootScope = $rootScope
    $state.bool = false
    this.window = $window;
    this.acl = {}
  }
  getStateDiff(array) {
    let diff = []
    let index = 0
    for (let i = 0; i < array.length; i++) {
      let key = 'setting-' + array[i];
      if (!(key in this.acl)) {
        diff[index++] = array[i]
      }
      // else if(this.acl[key].indexOf('view') < 0){
      //   diff[index++] = array[i]
      // to rescue user without view permission }
    }
    return diff
  }
  hasAcl(key) {
    key = 'setting-' + key
    if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
      return true;
    } else {
      return false;
    }
  }
  $onInit() {
    // let toDeregister = this.getStateDiff(this.$state.get('settings').children)
    // for (let i = 0; i < toDeregister.length; i++) {
    //   if (this.$state.get(toDeregister[i])) {
    //     this.$state.router.stateRegistry.deregister(toDeregister[i])
    //   }
    // }
    let defaultState;
    for (let key in this.acl) {
      if (this.acl[key].indexOf('view') >= 0) {
        defaultState = key
        break;
      }
    }
    if (this.$state.current.name == 'settings' && defaultState) {
      if (defaultState === 'setting-preventative-maintenance') {
        this.window.open('/v2/index.html#/preventative-maintenance', '_self');
      } else {
        this.$state.go(defaultState.replace('setting-', ''))
      }
    }
    this.$rootScope.$broadcast('routeChange', null);
  }
  go(url) {
    this.window.open(url, "_blank");
  }
}

export default SettingsController;


// WEBPACK FOOTER //
// ./client/app/components/settings/settings.controller.js